import { render } from "./ReabonnementAddPage.vue?vue&type=template&id=620e50ad&ts=true"
import script from "./ReabonnementAddPage.vue?vue&type=script&lang=ts"
export * from "./ReabonnementAddPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__